<div *ngIf="isLoading" class="backdrop">
  <div class="spinner-border text-light" role="status">
    <span class="visually-hidden">Carregando...</span>
  </div>
</div>
